import { render, staticRenderFns } from "./RoadReminders.vue?vue&type=template&id=1e68ac58"
import script from "./RoadReminders.vue?vue&type=script&lang=js"
export * from "./RoadReminders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports